<template>
    <div class="chat-node-wrapper container" :class="[
            'chat-node-wrapper-' + speaker,
            expectAnswer ? (pickedAnswer ? 'chat-node-wrapper-picked-answer' : 'chat-node-wrapper-expecting-answer') : '',
            loading ? 'chat-node-wrapper-loading' : '',
        ]">
        <div class="chat-node" v-if="loading">
            <no-drag-image class="loading-indicator"
                 src="@/assets/writing.gif" />
        </div>
        <div v-else class="chat-node-container">
            <div
                    v-for="(answer, answerName) in answers"
                    :key="answerName"

                    class="chat-node"
                    :class="[
                        pickedAnswer ? (pickedAnswer === answerName ? 'chat-node-picked' : 'chat-node-not-picked') : '',
                    ]"

                    v-on:click="onAnswerClick(answerName)"
            >
                <span class="message" v-html="answer.answerHtml" />
                <screen-reader-button :message="answer.answerTTS" class="screen-reader-button" :theme="speaker === 'npc' ? 'dark' : 'light'" />
            </div>
        </div>
    </div>
</template>

<script>
    import ScreenReaderButton from '@/components/screen-reader/ScreenReaderButton';
    import NoDragImage from "@/sgi/common/NoDragImage";

    export default {
        name: 'chat-node',
        components: {
            NoDragImage,
            ScreenReaderButton
        },
        props: {
            node: {
                type: Object
            }
        },
        data() {
            let answers = this.node.answers;

            for (let answerKey in answers) {
                let answer = answers[answerKey].answer;

                answers[answerKey].answerHtml = answer;
                answers[answerKey].answerTTS = this.getAnswerTTS(answer);
            }

            return {
                timeout: null,
                loading: true,
                pickedAnswer: null,

                name: this.node.name,
                speaker: this.node.speaker,
                answers: answers,
                answerNames: this.node.answerNames,
                answerLength: this.node.answerLength,
                exitType: this.node.exitType,
                uid: this.node.uid
            }
        },
        beforeDestroy() {
            if (this.timeout) {
                clearTimeout(this.timeout);

                this.timeout = null;
            }
        },
        updated() {
            if (!this.expectAnswer) {
                return;
            }

            let chatContainer = jQuery('.chat-container');

            let scrollHeight = chatContainer.prop('scrollHeight');
            let scrollTop = scrollHeight + 4000;

            chatContainer
                .stop(true)
                .animate({
                    scrollTop: scrollTop
                }, 1000);
        },
        mounted() {
            let timeout = this.expectAnswer ? 0 : Math.min(1000, Math.max(2000, this.answerLength * 10));

            if (timeout) {
                this.timeout = setTimeout(() => {
                    this.timeout = null;
                    this.loading = false;

                    this.$pling();

                    if (!this.expectAnswer) {
                        // Npc messages automatically continue
                        this.pickAnswer(this.answerNames[0]);
                    }
                }, timeout);
            } else {
                this.loading = false;
            }
        },
        computed: {
            expectAnswer() {
                return this.speaker === 'player';
            },
        },
        methods: {
            getAnswerTTS(answerText) {
                let temp = document.createElement('p');

                temp.innerHTML = answerText;

                return temp.textContent || temp.innerText;
            },
            onAnswerClick(answerName) {
                if (!this.expectAnswer) {
                    return; // Do not do anything as we're not expecting an answer
                }

                this.pickAnswer(answerName);
            },
            pickAnswer(answerName) {
                if (this.pickedAnswer) {
                    return; // You cannot pick multiple answers
                }

                this.pickedAnswer = answerName;

                this.$emit('pickedAnswer', this.answers[answerName], this.node);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chat-node-wrapper {
        padding: 0 10px;
        $nodePadding: 20px;

        &.chat-node-wrapper-picked-answer.chat-node-wrapper-player .chat-node {
            cursor: default !important; // Do not show a cursor if you've already picked an answer
        }

        &.chat-node-wrapper-loading {
            .chat-node {
                padding: 10px !important;
            }
        }

        &.chat-node-wrapper-expecting-answer {
            max-width: 100%;
            min-width: 100%;
            text-align: center;
            padding-top: 10px;
            background: white;

            .chat-node-container {
                width: 350px;
                margin: 0 auto;

                .chat-node {
                    width: 100%;

                    text-align: center !important;
                }
            }
        }

        .chat-node {
            position: relative;
            border-radius: 23px;
            padding: $nodePadding $nodePadding ($nodePadding + 20px) $nodePadding;
            margin-bottom: 10px;
            display: inline-block;
            word-break: break-word;
            font-size: 16px;
            line-height: 135%;

            .screen-reader-button {
                position: absolute;
                bottom: 5px;
                right: 5px;
            }
        }

        &.chat-node-wrapper-npc {
            text-align: left;

            .chat-node {
                background: #F1F0F0;
            }
        }

        &.chat-node-wrapper-player {
            text-align: right;

            .chat-node {
                background: #494f6d;

                color: white;
                cursor: pointer;

                &.chat-node-picked {
                    //background: green;
                }

                &.chat-node-not-picked {
                    display: none;
                    background: red;
                }
            }
        }
    }

    .chat-node-wrapper {
        width: 600px;
        max-width: 100%;
        margin: 0 auto;
    }
</style>
